import React, { useState } from "react";

const StepEnterDetails = ({
  companyName,
  setCompanyName,
  email,
  setEmail,
  error,
  handleContinueToRegister,
}) => {
  const [emailError, setEmailError] = useState(""); // State to handle email validation errors

  // Function to validate email format
  const validateEmail = (email) => {
    // Basic regex to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Function to handle the "Continue" button click
  const handleFormSubmit = () => {
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    setEmailError(""); // Clear email error if valid
    handleContinueToRegister(); // Proceed to the next step
  };

  return (
    <form className="register-form" onSubmit={(e) => e.preventDefault()}>
      <h2 className="register-title">Enter Your Details</h2>
      {error && <p className="error-message">{error}</p>}
      <input
        type="text"
        placeholder="Company Name"
        className="register-input"
        value={companyName}
        onChange={(e) => setCompanyName(e.target.value)}
        required
      />
      <input
        type="email"
        placeholder="Email"
        className="register-input"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      {emailError && <p className="error-message">{emailError}</p>}
      <button
        type="button"
        className="register-button"
        onClick={handleFormSubmit}
      >
        Continue
      </button>
    </form>
  );
};

export default StepEnterDetails;
